export const BEAM_REGISTER_REPORT_REQUEST = 'BEAM_REGISTER_REPORT_REQUEST';
export const BEAM_REGISTER_REPORT_SUCCESS = 'BEAM_REGISTER_REPORT_SUCCESS';
export const BEAM_REGISTER_REPORT_FAILURE = 'BEAM_REGISTER_REPORT_FAILURE';